import css from './index.module.scss';

export default function LRMessage({ lTitle, rTitle, rTips }: { lTitle: any; rTitle: any; rTips?: string }) {
    return (
        <div className={`${css.LRMessage} LRMessage`}>
            <div className="LRMessage-l">{lTitle}</div>
            <div className="LRMessage-r">
                <div className="LRMessage-r-line1">{rTitle}</div>
                {rTips && <div className="LRMessage-r-line2">{rTips}</div>}
            </div>
        </div>
    );
}
